import { useRef } from 'react';

const useStyleAssigner = () => {
  const stylesMap = useRef({});

  const reset = () => {
    stylesMap.current = {};
  };

  const getStyles = key => stylesMap.current[key];
  const getStylesAttr = (key, attr) => getStyles(key)?.[attr];

  const setStyleAttr = (key, attr, value) => {
    if (!stylesMap.current[key]) stylesMap.current[key] = {};

    stylesMap.current[key][attr] = value;
  };

  const addClassName = (key, className) => {
    const currClassNames = getStylesAttr(key, 'classNames') || [];
    setStyleAttr(key, 'classNames', [...currClassNames, className]);
  };

  const removeClassName = (key, className) => {
    const currClassNames = getStylesAttr(key, 'classNames') || [];
    setStyleAttr(
      key,
      'classNames',
      currClassNames.filter(_className => className !== className)
    );
  };

  return {
    reset,
    getStyles,
    setStyleAttr,
    addClassName,
    removeClassName
  };
};

export default useStyleAssigner;
